module.exports = __webpack_public_path__ + "img/logo — копия (2).8d8c191a.png";